module.exports = __webpack_public_path__ + "static/media/circular-red-close-icon.824047fa.svg";